<template>
    <v-dialog
        v-model="showDialog"
        width="600"
        persistent
    >
        <v-card>
            <v-form
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-title
                    style="background-color: #009688; color: white;"
                >
                    Add new rate for: &nbsp;<v-chip v-if="data.MSU_C">
                        {{ data.MSU_C }}
                    </v-chip> &nbsp;{{ data.HOSP_NAME }}
                </v-card-title>
                <v-card-text>
                    <v-autocomplete
                        v-model="newData.RATE_TYPE"
                        :items="['INDIVIDUAL', 'PACKAGE']"
                        label="Rate Type"
                        color="teal"
                        :rules="[v => v !== '' && v !== null && v !== undefined && /[a-zA-Z]/.test(v) || 'This field is required']"
                        clearable
                    />
                    <div v-if="newData.RATE_TYPE === 'INDIVIDUAL'">
                        <v-combobox
                            key="rateType1"
                            v-model="newData.DIA_T"
                            :items="getAcuDiagnosticSuggestions && Array.isArray(getAcuDiagnosticSuggestions.data) ? getAcuDiagnosticSuggestions.data.filter(aItem => !rateItems.some(bItem => bItem.DIA_T.includes(aItem))) : []"
                            label="Diagnostic"
                            color="teal"
                            :rules="[v => v !== '' && v !== null && v !== undefined && /[a-zA-Z]/.test(v) || 'This field is required']"
                            clearable
                        />
                    </div>
                    <div v-else>
                        <v-text-field
                            key="rateType2"
                            v-model="newData.DIA_T"
                            label="Diagnostic"
                            color="teal"
                            :rules="[v => v !== '' && v !== null && v !== undefined && /[a-zA-Z]/.test(v) || 'This field is required']"
                            clearable
                        />
                    </div>
                    <v-checkbox
                        v-model="newData.USE_HMI_RATE"
                        label="Use HMI Rate"
                        style="padding: 20px 0; margin: 0;"
                        color="teal"
                        hide-details
                    />
                    <v-text-field
                        ref="newratephp"
                        v-model="newData.PHP_N"
                        :disabled="newData.USE_HMI_RATE"
                        label="Price"
                        color="teal"
                        :rules="newData.USE_HMI_RATE ? [()=>true] : requiredField.concat(isValidPHPN)"
                        clearable
                    />
                    <v-text-field
                        ref="newrateminage"
                        v-model="newData.MIN_AGE"
                        label="Min. Age"
                        color="teal"
                        :rules="[
                            (v) => v !== undefined && v !== null && !isNaN(v) || 'Must be a number.',
                            (v) => v <= newData.MAX_AGE || 'Must be less than or equal to Max Age'
                        ]"
                    />
                    <v-text-field
                        ref="newratemaxage"
                        v-model="newData.MAX_AGE"
                        label="Max. Age"
                        color="teal"
                        :rules="[
                            (v) => v !== undefined && v !== null && !isNaN(v) || 'Must be a number.',
                            (v) => Number(v) >= Number(newData.MIN_AGE) || 'Must be greater than or equal to Min Age'
                        ]"
                        hint="120 represents no upper age limit."
                    />
                    <v-checkbox
                        v-model="newData.HIDE_AGE_RESTRICTION"
                        label="Hide Age Restriction"
                        style="padding: 20px 0; margin: 0;"
                        color="teal"
                        hide-details
                    />
                    <v-text-field
                        key="rateAnnotation"
                        v-model="newData.ANNOTATION"
                        label="Annotation"
                        color="teal"
                        clearable
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        width="120"
                        @click="showDialog = false"
                    >
                        <v-icon>{{ mdiClose }}</v-icon>
                        close
                    </v-btn>
                    <v-btn
                        color="teal darken-1"
                        width="120"
                        style="color: white;"
                        type="submit"
                    >
                        <v-icon>{{ mdiCheck }}</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiClose,
    mdiCheck
} from '@mdi/js'

export default {
    props: ['show', 'data', 'rateItems'],
    data: ()=>({
        mdiClose,
        mdiCheck,
        // diagnostics: ['Chest X-ray', 'Complete Blood Count (CBC)', 'Electrocardiogram (ECG)', 'Pap Smear', 'Physical Examination', 'Routine Fecalysis', 'Routine Urinalysis', 'Taking of Medical History'],
        newData: {
            DIA_T: null,
            MSU_C: null,
            PHP_N: null,
            USE_HMI_RATE: false,
            RATE_TYPE: null,
            TYPE: null,
            MIN_AGE: null,
            MAX_AGE: null,
            HIDE_AGE_RESTRICTION: false,
            ANNOTATION: null
        },
        isValidPHPN: value => {
            if (value === '' || value === null) return true
            const regex = /^(0|[1-9]\d*)(\.\d+)?$/
            return regex.test(value) || 'Enter a non-negative number'
        },
        requiredField: [v=>!!v||'This field is required']
    }),
    computed: {
        ...mapGetters(['getAcuDiagnosticSuggestions', 'getPackageDiagnosticsData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
                this.resetForm()
            }
        }
    },
    watch: {
        data(newVal) {
            if (newVal) {
                this.defaultFormValue(newVal)
            }
        },
        'newData.USE_HMI_RATE' (newVal) {
            if (newVal) {
                this.newData.PHP_N = 0
                this.$nextTick(() => {
                    if (this.$refs) {
                        if (this.$refs['newratephp']) this.$refs['newratephp'].validate()
                    }
                })
            }
        },
        'newData.MIN_AGE' () {
            this.$nextTick(() => {
                if (this.$refs) {
                    if (this.$refs['newratemaxage']) this.$refs['newratemaxage'].validate()
                    if (this.$refs['newrateminage']) this.$refs['newrateminage'].validate()
                }

            })
        },
        'newData.MAX_AGE' () {
            this.$nextTick(() => {
                if (this.$refs) {
                    if (this.$refs['newratemaxage']) this.$refs['newratemaxage'].validate()
                    if (this.$refs['newrateminage']) this.$refs['newrateminage'].validate()
                }
            })
        }
    },
    methods: {
        ...mapActions(['addMsuRates', 'suggestAcuDiagnostics', 'getPackageDiagnostics']),
        submitForm() {
            if (this.$refs && this.$refs.form.validate()) {
                this.addMsuRates(this.newData).then(() => this.suggestAcuDiagnostics())
            }
        },
        resetForm() {
            if (this.$refs && this.$refs.form) {
                this.$refs.form.resetValidation()
                this.defaultFormValue(this.data)
            }
        },
        defaultFormValue(newVal) {
            this.newData = {
                DIA_T: null,
                MSU_C: newVal.MSU_C,
                PHP_N: null,
                USE_HMI_RATE: false,
                RATE_TYPE: 'INDIVIDUAL',
                TYPE: newVal.TYPE,
                MIN_AGE: 0,
                MAX_AGE: 120,
                HIDE_AGE_RESTRICTION: false,
                ANNOTATION: ''
            }
        }
    }
}
</script>
